import { NavigationItem } from "./models/navigation-item.model";
import { PermIdIndexerEnum } from "./models/permid-indexer-enum";

export class NavigationUtils {

      public static GetPermIdFromUrl(url: string): string {
        let linkId = '';
        if (url) {
          const urlParts = url.split('?');
          if (urlParts.length > 1) {
            const queryParams = urlParts[1];
            const params = queryParams.split('&');
            const linkParam = params.find(param => param.includes('linkid'));
            if (linkParam) {
              linkId = linkParam.split('=')[1];
            }
          }
        }
        return linkId;
      }

      public static GetParentPermId(permId: string) {
        const parts = (permId) ? permId.split('_') : new Array<string>();
        parts.pop();
        return parts.join('_');
      }

      public static GetSubscriptionIdNavItem(navItem: NavigationItem) {
        let id = '';
        if (navItem) {
          id = NavigationUtils.GetSubscriptionIdFromPermId(navItem.PermItemID);
        }
        return id;
      }

      public static GetSubscriptionIdFromPermId(permId: string): string {
        const parts = (permId) ? permId.split('_') : new Array<string>();
        const subIndex = PermIdIndexerEnum.Home as number;
        let id = (parts && parts.length > subIndex) ? parts[subIndex].replace('p', '') : '';
        return id;
      }

      public static GetHospitalIdNavItem(navItem: NavigationItem) {
        let id = '';
        if (navItem) {
          id = NavigationUtils.GetHospitalIdFromPermId(navItem.PermItemID);
        }
        return id;
      }

      public static GetUnitIdNavItem(navItem: NavigationItem) {
        let id = '';
        if (navItem) {
          id = NavigationUtils.GetUnitIdFromPermId(navItem.PermItemID);
        }
        return id;
      }

      public static GetHospitalIdFromPermId(permId: string): string {
        const parts = (permId) ? permId.split('_') : new Array<string>();
        const hospIndex = PermIdIndexerEnum.Hospital as number;
        let id = (parts && parts.length > hospIndex) ? parts[hospIndex] : '';
        id = id.replace('f', '');
        return id;
      }

      public static GetUnitIdFromPermId(permId: string): string {
        let id = '';
        if (permId && (permId !== undefined) && permId.includes('_u')) {
          const parts = (permId) ? permId.split('_') : new Array<string>();
          const unitIndex = PermIdIndexerEnum.Unit as number;
          id = (parts && parts.length > unitIndex) ? parts[unitIndex] : '';
          id = id.replace('u', '');
        }
        return id;
      }

      public static IsSubscriptionLevel(permId: string): boolean {
        const subid = NavigationUtils.GetSubscriptionIdFromPermId(permId);
        const isSubLevel = (subid !== '');
        return isSubLevel;
      }

      public static IsLastPartSubscriptionItem(navItem: NavigationItem): boolean {
        const isSub = NavigationUtils.IsLastPartSubscriptionItemFromPermId(navItem.PermItemID);
        return isSub;
      }

      public static IsLastPartSubscriptionItemFromPermId(permId: string): boolean {
        const navParts = (permId) ? permId.split('_') : new Array<string>();
        const lastPart = navParts[navParts.length - 1];
        const isSub = lastPart.startsWith('p') && !lastPart.includes('stub');
        return isSub;
      }

      public static IsHospitalLevel(permId: string): boolean {
        const hospid = NavigationUtils.GetHospitalIdFromPermId(permId);
        const unitid = NavigationUtils.GetUnitIdFromPermId(permId);
        const isHospLevel = (hospid !== '') && (unitid === '');
        return isHospLevel;
      }

      public static IsBeyondHopitalLevel(permId: string): boolean {
        const parts = permId.split('_');
        const hospIndex = PermIdIndexerEnum.Hospital as number;
        const isBeyondHospitalLevel = (parts && (parts.length > (hospIndex + 1)));
        return isBeyondHospitalLevel;
      }

      public static IsLastPartHospitalItemFromPermId(permId: string): boolean {
        const navParts = (permId) ? permId.split('_') : new Array<string>();
        const lastPart = navParts[navParts.length - 1];
        const isHosp = lastPart.startsWith('f');
        return isHosp;
      }

      public static IsLastPartUnitItemFromPermId(permId: string): boolean {
        const isStub = NavigationUtils.IsUnitStubFromPermId(permId);
        if (isStub) { return false; }

        const navParts = (permId) ? permId.split('_') : new Array<string>();
        const lastPart = navParts[navParts.length - 1];
        const isUnit = lastPart.startsWith('u');
        return isUnit;
      }

      public static IsLastPartHospitalIndicatorItemFromPermId(permId: string): boolean {
        const navParts = (permId) ? permId.split('_') : new Array<string>();
        const lastPart = navParts[navParts.length - 1];
        const isUnit = lastPart.includes('u0');
        return isUnit;
      }

      public static IsLastPartIndicatorItemFromPermId(permId: string): boolean {
        const navParts = (permId) ? permId.split('_') : new Array<string>();
        const lastPart = navParts[navParts.length - 1];
        const isIndicator = lastPart.startsWith('a');
        return isIndicator;
      }

      public static IsLastPartHospitalItem(navItem: NavigationItem): boolean {
        const isHosp = NavigationUtils.IsLastPartHospitalItemFromPermId(navItem.PermItemID);
        return isHosp;
      }

      public static IsUnitLevel(permId: string): boolean {
        const isUnit = NavigationUtils.IsLastPartUnitItemFromPermId(permId);
        return isUnit;
      }

      public static IsLastPartUnitItem(navItem: NavigationItem): boolean {
        const isUnit = NavigationUtils.IsLastPartUnitItemFromPermId(navItem.PermItemID);
        return isUnit;
      }

      public static IsLastPartIndicatorItem(navItem: NavigationItem): boolean {
        const isIndicator = NavigationUtils.IsLastPartIndicatorItemFromPermId(navItem.PermItemID);
        return isIndicator;
      }

      public static IsStubFromPermId(permId: string): boolean {
        const isStub = NavigationUtils.IsHospitalStubFromPermId(permId) || NavigationUtils.IsUnitStubFromPermId(permId);
        return isStub;
      }

      public static IsStub(navItem: NavigationItem): boolean {
        const isStub = navItem.PermItemID && navItem.PermItemID.includes('-stub');
        return isStub;
      }

      public static IsHospitalStub(navItem: NavigationItem): boolean {
        const isStub = NavigationUtils.IsHospitalStubFromPermId(navItem.PermItemID);
        return isStub;
      }

      public static IsHospitalStubFromPermId(permId: string): boolean {
        const isStub = permId.includes('-stubhosp');
        return isStub;
      }

      public static IsUnitStub(navItem: NavigationItem): boolean {
        const isStub = NavigationUtils.IsUnitStubFromPermId(navItem.PermItemID);
        return isStub;
      }

      public static IsUnitStubFromPermId(permId: string): boolean {
        const isStub = permId.includes('-stubunit');
        return isStub;
      }
}